/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.container[_ngcontent-%COMP%]{background:#fff;text-align:center;height:100vh;font-family:sans-serif;font-weight:900}.container[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{padding-bottom:20px}.container[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{padding-bottom:10px}.left-align[_ngcontent-%COMP%]{text-align:left;margin-left:30px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2NvbmZpcm1hdGlvbi9jb25maXJtYXRpb24uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay9zbGlwcmVzaXN0YW50L3NsaXByZXNpc3RhbnQvY2xpZW50L3NyYy9hcHAvY29uZmlybWF0aW9uL2NvbmZpcm1hdGlvbi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/$$_gendir/app/confirmation/confirmation.component.scss.shim.ngstyle.ts